const BASE_URL = "https://connections-api.herokuapp.com";

export { BASE_URL };
